import {
  Box,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Button,
  Select,
  InputLabel,
  IconButton,
  MenuItem,
  Checkbox,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Dialog,
  Autocomplete,
} from "@mui/material";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSystemConfig,
  getAllSysConfig,
  getSystemProvider,
  setSysConfig,
  updateSystemConfig,
  updateSystemConfigData,
} from "../../../Utils/actions";
import cogoToast from "cogo-toast";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import {
  MRT_EditActionButtons,
  MaterialReactTable,
} from "material-react-table";
import { useTranslation } from "react-i18next";
import { infoMsg } from "../../../Utils/errorMsg/ErrorMsg";
import { Add as AddIcon } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import { loadingOn } from "../../../Utils/utils";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { useLocation } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import { buttonStyle } from "../../../Style/ManualStyle";

const DataQuality = ({ dataProvider, rigsData, bUnitData, nodeInfo }) => {
  const { getSysConfigData, isConfigUser, getSysConfigDataTotalRecord } =
    useSelector((state) => state.data);
  const dispatch = useDispatch();
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState({});
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [dataProv, setDataProv] = useState(dataProvider);
  const [rigs, setRigs] = useState(rigsData);
  const [bUnit, setBUnit] = useState(bUnitData);
  const [nodeInf, setNodeInf] = useState(nodeInfo);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem("dpPageSize")
      ? sessionStorage.getItem("dpPageSize")
      : 10
  );
  const location = useLocation();
  const [dataProviderPagination, setDataProviderPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const isAtiveData = [
    { text: "Yes", value: "Y" },
    { text: "No", value: "N" },
  ];

  useEffect(() => {
    dispatch(getAllSysConfig(pageSize, pageIndex));
    dispatch(getSystemProvider());
  }, []);

  useEffect(() => {
    dispatch(getAllSysConfig(pageSize, pageIndex));
  }, [pageSize, pageIndex]);

  useEffect(() => {
    setDataProv(dataProvider);
    setRigs(rigsData);
    setBUnit(bUnitData);
    setNodeInf(nodeInfo);
  }, [dataProvider, rigsData, bUnitData, nodeInfo]);

  const searchableRigs = useMemo(() => rigs?.map((rig) => rig.text), [rigs]);

  sessionStorage.setItem("dpPageSize", pageSize);

  const { t } = useTranslation();
  const columns = useMemo(
    () => [
      {
        accessorKey: "rig",
        header: "Rig",
        editVariant: "select",
        editSelectOptions: rigs,
        muiEditTextFieldProps: {
          required: true,
        },
        muiEditSelectProps: {
          SelectProps: {
            classes: {
              select: "dropdown_vertical", // Add your custom class name here
            },
          },
        },
        filter: "text",
      },
      {
        accessorKey: "dataProvider",
        header: "Data Provider",
        editVariant: "select",
        editSelectOptions: dataProv,
        muiEditTextFieldProps: {
          required: true,
        },
        filter: "text",
      },
      {
        accessorKey: "bUnit",
        header: "Business Unit",
        editVariant: "select",
        editSelectOptions: bUnit,
        muiEditTextFieldProps: {
          required: true,
        },
        filter: "text",
      },
      {
        accessorKey: "node_info",
        header: "Node Info",
        editVariant: "select",
        editSelectOptions: nodeInf,
        muiEditTextFieldProps: {
          required: true,
        },
        filter: "text",
      },
      {
        accessorKey: "isActive",
        header: "Is Active",
        editVariant: "select",
        editSelectOptions: isAtiveData,
        muiEditTextFieldProps: {
          required: true,
        },
        muiEditSelectProps: {
          SelectProps: {
            classes: {
              select: "custom-select-class", // Add your custom class name here
            },
          },
        },
      },
    ],
    [t, rigs]
    //end
  );

  const transformedData = useMemo(() => {
    return getSysConfigData.map((row) => {
      return {
        ...row,
        isActive: row.isActive === "Y" ? "Yes" : "No",
      };
    });
  }, [getSysConfigData]);

  const onhandleSave = ({ row, table }) => {
    // dispatch(setSysConfig({ rig: 'Pattern', isActive: 'Y', dataProvider: 'Data Prov', bUnit: '2' }))
    dispatch(setSysConfig(row._valuesCache, pageSize, pageIndex));
    table.setCreatingRow(null);
  };

  const onEditHandle = ({ row, table }) => {
    const editedData = {
      ...row._valuesCache,
      // isActive: row._valuesCache.isActive === "Yes" ? "Y" : "N",
      id: row.original.id,
    };
    // dispatch(updateSystemConfig(row._valuesCache));
    // dispatch(updateSystemConfig(editedData));
    dispatch(updateSystemConfigData(editedData, pageSize, pageIndex));
    table.setEditingRow(null);
  };

  const createContentBox = ({ table, row, internalEditComponents }) => {
    <>
      <DialogTitle variant="h3">Create System Configuration</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        {internalEditComponents} {/* or render custom edit components here */}
      </DialogContent>
      <DialogActions>
        <MRT_EditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </>;
  };

  const onEditContent = ({ table, row, internalEditComponents }) => {
    <>
      <DialogTitle variant="h3">Edit System Configuration</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        {internalEditComponents} {/* or render custom edit components here */}
      </DialogContent>
      <DialogActions>
        <MRT_EditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </>;
  };

  const handleDeleteCancel = () => {
    setDeleteConfirm(false);
    setDeleteConfirmOpen(false);
  };

  const handleDeleteConfirm = () => {
    setDeleteConfirm(true);
    setDeleteConfirmOpen(false);
  };

  const openDeleteConfirmModal = (row) => {
    setDeleteConfirmOpen(true);
    setDeleteRow(row.original);
    // if (window.confirm("Are you sure you want to delete?")) {
    // }
  };

  useEffect(() => {
    if (deleteConfirm) {
      setDeleteConfirm(false);
      dispatch(loadingOn());
      dispatch(deleteSystemConfig(deleteRow, pageSize, pageIndex));
    }
  }, [deleteConfirmOpen]);

  // const handlePageChange = (newPagination) => {

  //   // setDataProviderPagination((prevState) => ({ ...prevState, pageIndex: newPagination.pageIndex }));
  //   setDataProviderPagination(newPagination);
  // };

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(getSysConfigDataTotalRecord / pageSize);
    setPageIndex(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  return (
    <Fragment>
      {/* <Card className="shadow-none" style={{ height: "100%" }}> */}
      {/* <Card.Header
          className="d-flex justify-content-center align-items-center shadow-none"
          style={{ border: "none", backgroundColor: "#286685", color: "#fff" }}
        >
          <strong>Add System Configuration</strong>
        </Card.Header> */}

      {/* <Card.Body> */}

      <Card
        className={"shadow-none w-100 data-provider-card"}
        style={
          location.pathname !== "/validForm"
            ? {
                backgroundColor: "#333333",
                padding: "15px",
                overflow: "auto",
                height: "89vh",
                border: "none",
                borderRadius: "unset",
              }
            : {
                border: "none",
                padding: "0px",
              }
        }
      >
        <Card.Body
          className={"data_provider_content"}
          style={
            location.pathname !== "/validForm"
              ? {
                  borderRadius: "0.25rem",
                  background: "#242424",
                  overflow: "hidden",
                  padding: "0px",
                }
              : {
                  padding: "0px",
                }
          }
        >
          <div
            className="col-dm-12"
            style={{ display: "block", overflow: "auto" }}
          >
            <div className="col-md-12 data-provider-table">
              <MaterialReactTable
                muiTabEditIconleHeadCellProps={{
                  sx: {
                    backgroundColor: "#2e2e2e",
                    color: "#ccc",
                  },
                }}
                muiTableProps={{
                  sx: {
                    overflow: "scroll",
                    border: "none",
                  },
                }}
                muiTableBodyRowProps={({ row, index }) => ({
                  sx: {
                    backgroundColor: row.getIsSelected()
                      ? "#1c1c1c"
                      : // : index % 2 === 0
                        // ? "#cfd5e959"
                        "#121212",
                  },
                })}
                muiTablePaperProps={{
                  sx: {
                    boxShadow: "none",
                    width: "100%", // Set width to 100% of the container
                    position: "relative",
                    display: "block",
                    // overflow: "scroll",
                  },
                }}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    backgroundColor: "#2e2e2e", // dark head
                    color: "#ccc",
                  },
                }}
                muiTableBodyProps={{
                  sx: {
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    backgroundColor: "#181818", // dark body
                    "&::-webkit-scrollbar": {
                      width: "12px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#444",
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#23272f",
                    },
                    // "& tr:nth-of-type(odd)": {
                    //   backgroundColor: "#23272f",
                    // },
                    // "& tr:nth-of-type(even)": {
                    //   backgroundColor: "#181818",
                    // },
                    "& td": {
                      padding: "0.5rem",
                      borderBottom: "1px solid #333",
                      color: "#c7c7c7",
                    },
                  },
                }}
                muiPaginationProps={({ table }) => ({
                  showRowsPerPage: true,
                })}
                // manualPagination={true}
                paginationDisplayMode="default"
                // onPaginationChange={handlePageChange}
                rowCount={getSysConfigDataTotalRecord}
                // muiTablePaperProps={{ sx: { boxShadow: "none" } }}
                enableStickyFooter={true}
                enableStickyHeader={true}
                columns={columns}
                data={transformedData}
                enableRowActions
                createDisplayMode="row"
                positionActionsColumn="last"
                onCreatingRowSave={onhandleSave}
                editDisplayMode={"row"}
                enableEditing={true}
                // enableFilters={false}
                enableHiding={false}
                // renderEditRowDialogContent={onEditContent}
                enableDensityToggle={false}
                getRowId={(row) => row.id}
                enableFullScreenToggle={false}
                renderCreateRowDialogContent={createContentBox}
                // paginationDisplayMode="default"
                // muiPaginationProps={}
                // state={dataProviderPagination}
                enablePagination={false}
                renderEditRowDialogContent={({
                  table,
                  row,
                  internalEditComponents,
                }) => {
                  return (
                    <>
                      {/* Your dialog content here */}
                      {internalEditComponents.map((component, index) => {
                        if (columns[index].editVariant === "autocomplete") {
                          return (
                            <Autocomplete
                              key={index}
                              options={columns[index].editSelectOptions}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  InputProps={{
                                    ...params.InputProps,
                                    type: "search",
                                  }}
                                />
                              )}
                            />
                          );
                        }
                        // Render other types of edit components if needed
                        return component;
                      })}
                    </>
                  );
                }}
                renderTopToolbar={({ table }) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      padding: "0.5rem 1rem",
                      flexWrap: "wrap",
                      gap: "1rem",
                      background: "#181818",
                    }}
                  >
                    {/* Left: Custom Search Field */}
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search..."
                      value={table.getState().globalFilter || ""}
                      onChange={(e) => table.setGlobalFilter(e.target.value)}
                      sx={{
                        minWidth: "250px",
                        input: { color: "#c7c7c7", background: "#272727" },
                        "& legend": {
                          display: "none",
                        },
                      }}
                    />

                    {/* Right: Filter + Create Button */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {/* Just the filter icon (toggle column filters) */}
                      <Tooltip title="Show Filters">
                        <IconButton
                          onClick={() =>
                            table.setShowColumnFilters(
                              !table.getState().showColumnFilters
                            )
                          }
                        >
                          <FilterListIcon />
                        </IconButton>
                      </Tooltip>

                      {/* Create Button */}
                      {(location.pathname === "/validForm" ||
                        cmpntGroup["dataProvider"]?.Add) && (
                        <div className="d-flex">
                          <Button
                            // variant="contained"
                            startIcon={<AddIcon />}
                            style={{
                              // ...buttonStyle,
                              background:
                                "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                              border: "1px solid #3a3a3a",
                              color: "#ffffff",
                              // fontSize: "5px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                              transition:
                                "background 0.3s ease, transform 0.2s ease",
                              // backgroundColor: "#286685",
                              // color: "#fff",
                              marginRight: "10px",
                              width: "100px",
                            }}
                            onClick={() => {
                              table.setCreatingRow(true);
                            }}
                          >
                            Create
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                renderBottomToolbarCustomActions={({ table }) => (
                  <>
                    <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
                      <span>Rows per Page </span>&nbsp;
                      <FormControl variant="standard" size="small">
                        <Select
                          value={pageSize}
                          onChange={(e) =>
                            handlePageSizeChange(Number(e.target.value))
                          }
                          sx={{
                            color: "#c7c7c7",
                            ".MuiSelect-icon": { color: "#c7c7c7" },
                            ".MuiOutlinedInput-notchedOutline": {
                              borderColor: "#444",
                            },
                          }}
                        >
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                      &nbsp;
                      <span>
                        {pageIndex * pageSize + 1}-
                        {Math.min(
                          pageIndex * pageSize + pageSize,
                          getSysConfigDataTotalRecord
                        )}{" "}
                        of &nbsp;
                        {getSysConfigDataTotalRecord}&nbsp;
                      </span>
                      <FirstPageIcon
                        onClick={() => {
                          if (pageIndex !== 0) {
                            handleStartChange();
                          }
                        }}
                        style={{
                          cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                          color:
                            pageIndex === 0
                              ? "rgba(255,255,255,0.26)"
                              : "inherit",
                        }}
                      />
                      <NavigateBeforeIcon
                        onClick={() => {
                          if (pageIndex !== 0) {
                            handlePageChange(pageIndex - 1);
                          }
                        }}
                        style={{
                          cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                          color:
                            pageIndex === 0
                              ? "rgba(255,255,255,0.26)"
                              : "inherit",
                        }}
                      />
                      <NavigateNextIcon
                        onClick={() => {
                          if (
                            (pageIndex + 1) * pageSize <
                            getSysConfigDataTotalRecord
                          ) {
                            handlePageChange(pageIndex + 1);
                          }
                        }}
                        style={{
                          cursor:
                            (pageIndex + 1) * pageSize >=
                            getSysConfigDataTotalRecord
                              ? "not-allowed"
                              : "pointer",
                          color:
                            (pageIndex + 1) * pageSize >=
                            getSysConfigDataTotalRecord
                              ? "rgba(255,255,255,0.26)"
                              : "inherit",
                        }}
                      />
                      <LastPageIcon
                        onClick={() => {
                          if (
                            (pageIndex + 1) * pageSize <
                            getSysConfigDataTotalRecord
                          ) {
                            handleEndChange();
                          }
                        }}
                        style={{
                          cursor:
                            (pageIndex + 1) * pageSize >=
                            getSysConfigDataTotalRecord
                              ? "not-allowed"
                              : "pointer",
                          color:
                            (pageIndex + 1) * pageSize >=
                            getSysConfigDataTotalRecord
                              ? "rgba(255,255,255,0.26)"
                              : "inherit",
                        }}
                      />
                    </div>
                  </>
                )}
                // createDisplayMode: 'modal'
                onEditingRowSave={onEditHandle}
                renderRowActions={({ row, table }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <Tooltip title="Edit">
                      {(location.pathname === "/validForm" ||
                        cmpntGroup["dataProvider"]?.Update) && (
                        <IconButton
                          // sx={{ color: "#286685" }}
                          onClick={() => {
                            table.setEditingRow(row);
                          }}
                        >
                          <EditIcon sx={{ color: "#c7c7c7" }} />
                        </IconButton>
                      )}
                    </Tooltip>
                    <Tooltip title="Delete">
                      {(location.pathname === "/validForm" ||
                        cmpntGroup["dataProvider"]?.Delete) && (
                        <IconButton
                          // sx={{ color: "#286685" }}
                          onClick={() => {
                            openDeleteConfirmModal(row);
                            // data.splice(row.index, 1); //assuming simple data table
                            // setData([...allUserdata]);
                          }}
                        >
                          <DeleteIcon sx={{ color: "#c7c7c7" }} />
                        </IconButton>
                      )}
                    </Tooltip>
                  </Box>
                )}
              />
            </div>
            <div>
              <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
                <DialogTitle
                  style={{ backgroundColor: "#161616", color: "#c7c7c7" }}
                >
                  Delete Confirmation
                </DialogTitle>
                <DialogContent>
                  <p>Are you sure you want to delete the item?</p>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleDeleteCancel} color="primary">
                    Cancel
                  </Button>
                  <Button
                    style={{ buttonStyle }}
                    onClick={handleDeleteConfirm}
                    color="error"
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            {/* <div>
                                <Button type="submit" style={{backgroundColor:'#286685', color: '#fff'}} startIcon={<SaveIcon />} onClick={()=> {isConfigUser ? setTabs(2) : infoMsg("Please Add System Configuration data.", "System Config") }}>
                                    Save
                                </Button>
                            </div> */}
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default DataQuality;
